module.exports = __webpack_public_path__ + "static/img/13.bc33c94.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pic/13.jpg
// module id = sxuQ
// module chunks = 1